module.exports = __webpack_public_path__ + "static/test_bitpay_token_approve-deb08133fdc5b68f47821d4392366f78.png";